import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { FormControl } from '@sravni/react-design-system/lib/FormControl';
import type { RadioButtonProps } from '@sravni/react-design-system/lib/RadioButton';
import { RadioButton } from '@sravni/react-design-system/lib/RadioButton';
import { Space } from '@sravni/react-design-system/lib/Space';

type Props = {
  name?: string;
  onValueChange?: (value) => void;
} & RadioButtonProps;

const DebtTypeInput = (props: Props) => {
  const { name = 'debtType', options, size = 52, onValueChange, defaultValue } = props;

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const rhfError = errors?.[name];
  const errorMessage = rhfError?.message;

  return (
    <FormControl invalid={!!errorMessage}>
      <Space direction="vertical" size={4}>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field: { value: fieldValue, onChange } }) => (
            <RadioButton
              value={fieldValue}
              onChange={(v) => {
                onChange(v);
                onValueChange?.(v);
              }}
              options={options}
              size={size}
            />
          )}
        />
        <FormControl.HelperText>{errorMessage}</FormControl.HelperText>
      </Space>
    </FormControl>
  );
};

export default DebtTypeInput;
